export default "__VITE_ASSET__BsuchNQK__"